<template>
  <div styleName="opt_video_wrap">
    <TeacherVideo />
  </div>
</template>
<script>
import TeacherVideo from './t.vue'
import CSSModules from 'vue-css-modules'
import styles from './index.scss'
export default {
  mixins: [CSSModules(styles)],
  components: {
    TeacherVideo
  }
}
</script>
